export default __webpack_public_path__ + "static/media/icon-pencil.19ca83b4.svg";